import { useEffect, useState } from "react";

/**
 * Hook to manage a timed loading state
 *
 * @param duration - Duration in seconds before loading completes
 * @returns Boolean indicating if still loading
 */
export const useLoadingTimer = (duration = 1): boolean => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show loading for specified duration
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, duration * 1000);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [duration]);

  return isLoading;
};
